import React from 'react';

/**
 * Single, shared full-screen loading state for the entire authentication flow
 * (callback handling, token settling, backend verification). Every auth-related
 * "please wait" screen renders THIS component so the transitions between them
 * are visually seamless — the user sees one continuous loader instead of a
 * flash between differently-styled spinners.
 */
const AuthLoading = ({ message = 'Signing you in…' }) => (
  <div style={styles.container}>
    <div style={styles.spinner} />
    <p style={styles.message}>{message}</p>
  </div>
);

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#ffffff',
    padding: '2rem',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid rgba(255, 255, 255, 0.3)',
    borderTop: '4px solid #ffffff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '1rem',
  },
  message: {
    fontSize: '1rem',
  },
};

if (typeof document !== 'undefined' && !document.getElementById('auth-spin-keyframes')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'auth-spin-keyframes';
  styleSheet.innerHTML = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
  document.head.appendChild(styleSheet);
}

export default AuthLoading;
